import Vue from 'vue'
Vue.config.productionTip = false

export const util = {
  itemsToString (items) {
    let str = ''
    let i
    for (i = 0; i < items.length; i++) {
      str += items[i].title
      if (i < (items.length - 1)) {
        str += ', '
      }
    }
    return str
  },
  getViewport () {
    let viewPortWidth
    let viewPortHeight

    if (typeof window.innerWidth !== 'undefined') {
      viewPortWidth = window.innerWidth
      viewPortHeight = window.innerHeight
    } else if (typeof document.documentElement !== 'undefined' && typeof document.documentElement.clientWidth !== 'undefined' && document.documentElement.clientWidth !== 0) {
      viewPortWidth = document.documentElement.clientWidth
      viewPortHeight = document.documentElement.clientHeight
    } else {
      viewPortWidth = document.getElementsByTagName('body')[0].clientWidth
      viewPortHeight = document.getElementsByTagName('body')[0].clientHeight
    }
    return {
      width: viewPortWidth, 
      height: viewPortHeight
    }
  }
}